export default __webpack_public_path__ + "static/media/icon-clock-gray.f128f5dc.svg";